import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Col, Container, Row } from 'react-bootstrap';
import Button from '../../../components/Button';
import Link from '../../../components/Link';
import CustomSelect from '../../../components/Select';
import {
  addOrRemoveMonthsToGivenDate,
  DateFormats,
  formatDate,
} from '../../../utils/utils';

const options = [
  {
    value: '1',
    label: `${formatDate(
      addOrRemoveMonthsToGivenDate(new Date(), -1),
      DateFormats.M_YEAR
    )}`,
  },
  {
    value: '2',
    label: `${formatDate(
      addOrRemoveMonthsToGivenDate(new Date(), -2),
      DateFormats.M_YEAR
    )}`,
  },
  {
    value: '3',
    label: `${formatDate(
      addOrRemoveMonthsToGivenDate(new Date(), -3),
      DateFormats.M_YEAR
    )}`,
  },
  {
    value: '4',
    label: `${formatDate(
      addOrRemoveMonthsToGivenDate(new Date(), -4),
      DateFormats.M_YEAR
    )}`,
  },
  {
    value: '5',
    label: `${formatDate(
      addOrRemoveMonthsToGivenDate(new Date(), -5),
      DateFormats.M_YEAR
    )}`,
  },
  {
    value: '6',
    label: `${formatDate(
      addOrRemoveMonthsToGivenDate(new Date(), -6),
      DateFormats.M_YEAR
    )}`,
  },
  {
    value: '7',
    label: `${formatDate(
      addOrRemoveMonthsToGivenDate(new Date(), -7),
      DateFormats.M_YEAR
    )}`,
  },
  {
    value: '8',
    label: `${formatDate(
      addOrRemoveMonthsToGivenDate(new Date(), -8),
      DateFormats.M_YEAR
    )}`,
  },
  {
    value: '9',
    label: `${formatDate(
      addOrRemoveMonthsToGivenDate(new Date(), -9),
      DateFormats.M_YEAR
    )}`,
  },
  {
    value: '10',
    label: `${formatDate(
      addOrRemoveMonthsToGivenDate(new Date(), -10),
      DateFormats.M_YEAR
    )}`,
  },
  {
    value: '11',
    label: `${formatDate(
      addOrRemoveMonthsToGivenDate(new Date(), -11),
      DateFormats.M_YEAR
    )}`,
  },
];

const PayNowCreditActionRequiredSummary = () => {
  const calculatedDate = new Date().toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
  });

  console.log(calculatedDate.split(' ').join(', '));
  return (
    <Container>
      <Container
        className={
          'cnd-custom-container-small my-12 px-0 px-lg-0 border-light-gray rounded-1'
        }
      >
        <div className="d-flex flex-column px-10 py-11 px-lg-11 bg-white solid-salmon-border rounded-border-bottom">
          <section className="d-flex justify-content-start">
            <h5 className="m-0">Action Required</h5>
          </section>
          <section className="d-flex justify-content-start mt-7">
            <span className="fw-light text-sub1 lh-xs">
              To make a payment by check or money order, select and print the
              appropriate statement and mail it along with your payment. It
              typically takes from 5 – 10 business days for us to receive and
              process this type of payment.
            </span>
          </section>

          <Row className="flex-column flex-lg-row justify-content-lg-between mt-7">
            <Col className={'col-12'}>
              <span className="fw-normal text-sub1 lh-xs d-flex align-items-center">
                STEP 1 - Select and print the appropriate statement.
              </span>
            </Col>

            <Col className={'col-12'}>
              <Row className={'align-items-center mt-7'}>
                <Col className={'col-12 col-lg-6'}>
                  <CustomSelect
                    placeholder={'Select Statement'}
                    options={options}
                    onChange={() => console.log("I'm changed")}
                    className="me-4"
                  />
                </Col>

                <Col
                  className={
                    'col-12 col-lg-6 mt-7 mt-lg-0 text-start text-lg-end'
                  }
                >
                  <Link
                    href={`${
                      process.env.PUBLIC_URL
                    }/${'blank-demo-example.pdf'}`}
                    target={'_blank'}
                  >
                    <Button
                      leftIcon={light('file-pdf')}
                      variant="danger"
                      className={'order-1 order-lg-3 mt-7 mt-lg-0'}
                      size="sm"
                    >
                      Download/Print
                    </Button>
                  </Link>
                </Col>
              </Row>
            </Col>
          </Row>

          <Row className="flex-column justify-content-start mt-7">
            <Col className={'col-12'}>
              <span className="fw-normal text-sub1 lh-xs">STEP 2 - Send</span>
            </Col>
            <Col className={'col-12'}>
              <span className="fw-light text-sub1 lh-xs">
                Send the statement and the ckeck / money order to the below
                address.
              </span>
            </Col>
          </Row>

          <Row className={'flex-lg-row flex-sm-column'}>
            <Col className={'col-12 col-lg-6 d-flex flex-column mt-7'}>
              <span className="fw-light text-sub1 lh-xs">Regular Mail</span>
              <span className="fw-light text-sub1 lh-xs">
                Interlink
              </span>
              <span className="fw-light text-sub1 lh-xs">Benefits Express</span>
              <span className="fw-light text-sub1 lh-xs">P.O. Box 5241</span>
              <span className="fw-light text-sub1 lh-xs">
                Cherry Hill, NJ 08034-5241
              </span>
            </Col>

            <Col className={'col-12 col-lg-6 d-flex flex-column mt-7'}>
              <span className="fw-light text-sub1 lh-xs">
                Overnight Delivery
              </span>
              <span className="fw-light text-sub1 lh-xs">
                Benefits Express Employee Service Center
              </span>
              <span className="fw-light text-sub1 lh-xs">
                101 Woodcrest Road
              </span>
              <span className="fw-light text-sub1 lh-xs">
                Cherry Hill, NJ 08003
              </span>
            </Col>
          </Row>

          <Row className="mt-7">
            <Col className={'col-12'}>
              <span className="fw-normal text-sub1 lh-xs">Review</span>
            </Col>
            <Col className={'col-12'}>
              <span className="fw-light text-sub1 lh-xs">
                Once your completed paperwork has been received it will be
                reviewed. If there are any problems with the paperwork you will
                be notified...
              </span>
            </Col>
          </Row>
        </div>
      </Container>
    </Container>
  );
};

export default PayNowCreditActionRequiredSummary;
